import { render } from "./Options.vue?vue&type=template&id=193cff78&scoped=true"
import script from "./Options.vue?vue&type=script&lang=js"
export * from "./Options.vue?vue&type=script&lang=js"

import "./Options.vue?vue&type=style&index=0&id=193cff78&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-193cff78"]])

export default __exports__